import {Component, OnChanges, Input, Output, OnInit, Injector, ViewChild} from '@angular/core';
import { Staff } from './contact';
import { Practice } from '../practices/practice';
import { ContactService } from '../../../services/contact.service'
import { SimpleChanges } from '@angular/core';
import {PhoneService} from '../../../voice-call/phone.service';
import {UserComponent} from '../../users/user/user.component';
import {AlertService} from "../../../_alert";

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss']
})
export class ContactsComponent implements OnInit {
  public staffs = Array<Staff>();
  @Input() practice: Practice;
  @Input() practice_permissions: string;
  public selected_index: number;
  show_contact = false;
  public  pencil: boolean;
  public dom_count: number;
  public edit_contact: boolean;
  public new_staff: Staff = new Staff();
  @ViewChild('userModal') userModal;
  customInjectorForPopup: Injector;
  showUserModel = false;
  userComponent = UserComponent;
  constructor(private contactService: ContactService, public phoneService: PhoneService, public injector: Injector,
  public alertService: AlertService) {
  }

  ngOnInit() {
    console.log('staffs', this.staffs)
    this.getContacts();
  }
  show_pencil(index) {
    this.dom_count = index;
    this.pencil = true;

  }
  hide_pencil() {
    this.pencil = false;
  }
  toggle_contact() {
    if (!(this.selected_index || this.selected_index == 0) && this.show_contact) {
      this.new_staff = new Staff();
      this.hide_form();
    } else {
      this.selected_index = null;
      this.show_form();
    }
  }
  sync_staff(event) {
    this.staffs.push(event.load_from_jason(event));
    this.practice.staffs = this.staffs;
    this.hide_form();
    this.new_staff = new Staff();
  }
  select_contact(index) {
    this.selected_index = index;
    this.show_form();
  }
  hide_form() {
    this.show_contact = false;
  }
  show_form() {
    this.show_contact = true;
  }
  reset_show_contact(event) {
    this.hide_form();
    this.new_staff = new Staff();
  }
  editContact() {
    this.edit_contact = !this.edit_contact;
  }
  delete(staff: Staff) {
      this.contactService.delete(staff.id).then(response => {
        if (response.status) {
          this.staffs.splice(this.staffs.indexOf(staff), 1)
          this.alertService.success('Deleted successfully', this.alertService.options);
        }
        this.practice.staffs = this.staffs;
      }
      )
  }

  createUpdateUser(staff) {
    let user = staff.user
    let profile_type = user.profileable_type ? user.profileable_type : (staff.practice_id ? 'practice' : '');
    this.customInjectorForPopup  = Injector.create([
      {provide: 'id', useValue: user.id},
      {provide: 'isContactPage', useValue: true},
      {provide: 'profile_type', useValue:  profile_type},
      {provide: 'profileable_id', useValue:  user.profileable_id},
      {provide: 'staff', useValue: staff},
      {
        provide: 'onUserSavedHandler',
        useValue: () => this.onUserSaved()
      }
    ], this.injector);
    this.showUserModel = true;
    this.userModal.show();
  }

  onUserSaved() {
    this.userModal.hide();
    this.showUserModel = false;
    this.staffs = [];
    this.getContacts();
  }

  getContacts() {
    this.contactService.getContacts(this.practice.id).then(contacts => {
      for (let contact of contacts) {
        this.staffs.push(new Staff().load_from_jason(contact));
      }
    })
  }
}

